import {
    REQUEST_LOGIN,
    LOGIN_SUCCEEDED,
    LOGIN_API_MESSAGES_SHOW,
    LOGIN_FAILED,
    REQUEST_REGISTER,
    REGISTER_SUCCEEDED,
    REGISTER_API_MESSAGES_SHOW,
    REQUEST_LOGIN_GUEST, LOGIN_SUCCEEDED_GUEST, LOGIN_API_FACEBOOK, LOGIN_API_GOOGLE, SEND_TEMPORARY_PASSWORD, RESET_PASSWORD, CHANGE_PASSWORD
} from './types';

export const requestLogin = (payload) => ({
    type: REQUEST_LOGIN,
    payload,
});

export const loginSucceeded  = (payload) => ({
    type: LOGIN_SUCCEEDED,
    payload,
});

export const loginFailed  = (payload) => ({
    type: LOGIN_FAILED,
    payload,
});

export const loginApiMessagesShow  = (payload) => ({
    type: LOGIN_API_MESSAGES_SHOW,
    payload,
});

export const requestRegister = (payload) => ({
    type: REQUEST_REGISTER,
    payload,
});

export const registerSucceeded  = (payload) => ({
    type: REGISTER_SUCCEEDED,
    payload,
});

export const registerApiMessagesShow  = (payload) => ({
    type: REGISTER_API_MESSAGES_SHOW,
    payload,
});

export const requestLoginGuest = (payload) => ({
    type: REQUEST_LOGIN_GUEST,
    payload,
});

export const loginSucceededGuest  = (payload) => ({
    type: LOGIN_SUCCEEDED_GUEST,
    payload,
});

export const requestLoginFacebook = (payload) => ({
    type: LOGIN_API_FACEBOOK,
    payload
});

export const requestLoginGoogle = (payload) => ({
    type: LOGIN_API_GOOGLE,
    payload
});

export const sendTemporaryPassword = (payload) => ({
    type: SEND_TEMPORARY_PASSWORD,
    payload
})

export const resetPassword = (payload) => ({
    type: RESET_PASSWORD,
    payload
})

export const changePassword = (payload) => ({
    refresh: true,
    type: CHANGE_PASSWORD,
    payload
})


// WEBPACK FOOTER //
// ./src/SHARED/actions/user.actions.js